module.exports = "/_next/static/resources/blavka-1-97c0437efeabfca0b453e5a94e86d28a.jpg";